var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GChart',{attrs:{"type":_vm.chartType,"data":_vm.chartData,"options":_vm.chartOptions,"create-chart":(el, google, type) => {
      return new google.visualization[type](el)
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }